/**
 * colsSettingParam 参数的说明和取的位置：
 */
import React, { Component, Fragment } from 'react';
import Button from '../../Button';
import Tooltip from '../../Tooltip';
import ButtonGroup from '../../ButtonGroup';
import Dnd from '../../Dnd';
import { toast, isString } from '@platform/api';
import HotKeys from '../../HotKeys';
import Sidebox from '../../Sidebox';
import Input from '../../-FormControl';

export default class ColSettingSideBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayData: props.leftData, //左侧待选列显示模板
            sortData: props.rightData, //被选择排序的列显示模板
        };
        this.lockTotal = 0; //被锁定不能拖拽的列个数
        //this.keySessionS = ''; //localStorage缓存页面模板的key
    }

    componentWillUnmount() {
    }

    //拖拽结束
    onDragEnd = result => {
        let { sortData } = this.state;
        // 过滤下visible为false的数据，拖拽排序是以所有的可见的数据排序的，需要根据拖拽返回的索引找到 sortData 内部真实的index
        let visibleData = sortData.filter(item=>item.visible);
        let unlockSortData = sortData.filter(val => val.islock !== true);
        let lockSortData = sortData.filter(val => val.islock === true);
        let { source, destination } = result;
        let startIndex = source.index;
        let endIndex = destination.index;
        startIndex = sortData.findIndex(item=>item.attrcode ===visibleData[startIndex].attrcode);
        endIndex = sortData.findIndex(item=>item.attrcode ===visibleData[endIndex].attrcode);
        let data1 = unlockSortData.splice(startIndex, 1);
        unlockSortData.splice(endIndex, 0, data1[0]);
        let newSortData = lockSortData.concat(unlockSortData);
        this.setState({ sortData: newSortData });
    };

    //点击选中侧拉左侧的列label事件
    chooseColumn = ele => {
        let { displayData } = this.state;
        let { sortData } = this.state;
        if (ele.showItem === true) {
            let newSortData = sortData.filter(val => val.attrcode !== ele.attrcode);
            let newDisplayData = displayData.map(val => {
                if (val.attrcode === ele.attrcode) {
                    //左侧隐藏
                    val.showItem = false;
                    val.islock = false;
                    //右侧显示
                    val.visible = true;
                    newSortData.push(val);
                }
                return val;
            });

            this.setState({
                displayData: newDisplayData,
                sortData: newSortData,
            });
        }
    };

    handleInputChange = (direction, value) => {
        switch (direction) {
            case 'left':
                this.setState({ leftKeyWord: value }, () => {
                    if (value) {
                        let searchFirstResult = document.querySelector('.TableColumnContent-left .selectBykeyword');
                        searchFirstResult && searchFirstResult.scrollIntoView();
                    } else {
                        document.querySelector('.TableColumnContent-left').scrollTop = 0;
                    }
                });
                break;
            case 'right':
                this.setState({ rightKeyWord: value }, () => {
                    if (value) {
                        let searchFirstResult = document.querySelector('.TableColumnContent-right .selectBykeyword');
                        searchFirstResult && searchFirstResult.scrollIntoView();
                    } else {
                        document.querySelector('.TableColumnContent-right').scrollTop = 0;
                    }
                });
                break;
            default:
                break;
        }

    }

    //点击X按钮让某一列隐藏
    ToHideOneCol = ele => {
        let { sortData, displayData } = this.state;
        if (ele.visible === true) {
            // let newSortData = sortData.filter(val => val.attrcode !== ele.attrcode);
            let newSortData = sortData.map(val => {
                if (val.attrcode === ele.attrcode) {
                    val.visible = false;
                    return val;
                }
                return val;
            });
            displayData = displayData.map(val => {
                if (val.attrcode === ele.attrcode) {
                    val.showItem = true;
                }
                return val;
            });
            this.setState({
                sortData: newSortData,
                displayData,
            });
        }
    };

    //点击锁锁定该列之前的列 锁定之后该列以及之前的列不参与排序
    ToLockCols = (ele, index) => {
        let { sortData } = this.state;
        /******************解决冻结所有列问题start**********************/
        let { tableScope } = this.props;
        let { json = {} } = tableScope.state;
        // 如果之前有很多列被冻结，那这里取到的 u-table-body 的宽度就会很小
        // let tableBody = tableScope.table.querySelector('.nc-table-body');
        let tableBody = tableScope.table;
        let checkBoxCol = tableBody.querySelector('.table-checkbox-class');
        let indexCol = tableBody.querySelector('.table-index');
        let tableBodyWidth = 0;
        if (tableBody) { tableBodyWidth = tableBody.offsetWidth; }
        let checkBoxColWidth = (checkBoxCol && checkBoxCol.offsetWidth) || 0;
        let indexColWidth = (indexCol && indexCol.offsetWidth) || 0;
        //第一列到点击的列的总宽度
        let toClickColWidth = 0;
        for (let i = 0, len = sortData.length; i < len; i++) {
            if (i == index) {
                break;
            }
            let width = sortData[i].width;
            if (isString(sortData[i].width)) {
                width = Number(sortData[i].width.replace(/px/, ''));
            }
            toClickColWidth += width;
        }
        // 要考虑固定列的宽度和border
        if (tableBodyWidth - checkBoxColWidth - indexColWidth - 2 < toClickColWidth) {
            toast({
                duration: 'infinity',
                color: 'warning',
                content: json['table_colseting_tip14'],
                mark: 'lock-tip',
            });
            return;
        }
        /***************** end**********************/
        let toLock = true;

        if (!ele.lock) {
            let afterLockData = sortData.map(val => {
                if (toLock === true && !val.islock) {
                    val.islock = true;
                    if (val.visible) { this.lockTotal++; }
                }
                if (val.attrcode === ele.attrcode) {
                    toLock = false;
                }
                return val;
            });
            this.setState({ sortData: afterLockData });
        }
    };

    //解锁
    ToUnLockCols = ele => {
        let { sortData } = this.state;
        if (ele.islock === true) {
            sortData = sortData.map(val => {
                if (val.islock === true) {
                    val.islock = false;
                    if (val.visible) { this.lockTotal--; }
                }
                return val;
            });
            this.setState({ sortData });
        }
    };

    //删除列里可能包含虚拟dom的字段
    deleteVDom = col => {
        let excludeVDom = Object.assign({}, col);
        delete excludeVDom.title;
        delete excludeVDom.sorter;
        delete excludeVDom.render;
        delete excludeVDom.width;
        return excludeVDom;
    };

    //点击侧拉header的确定按钮
    onColsSetting = () => {
        let { onColsSetting } = this.props;
        let { sortData } = this.state;
        onColsSetting && onColsSetting(sortData);
    };

    //点击重置 重置列设置
    onColReset = () => {
        let { onColReset } = this.props;
        onColReset && onColReset();
    };

    iconfontCls = (fontName, another) => {
        return `icon iconfont icon-${fontName} ${another}`;
    };

    //侧拉的头部结构
    DrawerHeader = () => {
        let { tableScope, toCloseDrawer } = this.props;
        // let { colsSettingParam } = this.props;
        let { json = {} } = tableScope.state;
        // if (colsSettingParam) {
        let LIST = [
            {
                title: json['table_colseting_ok'], //确定
                colors: 'primary',
                key: 'confirm',
                onClick: this.onColsSetting,
                className: 'button-primary',
            },
            {
                title: json['table_colseting_reset'], //重置
                key: 'reset',
                colors: 'secondary',
                onClick: this.onColReset,
            },
        ];

        const tip = (
            <div className='col-setting-tips-overlay'>
                <p>{json['table_colseting_tip05']}：</p>
                <p>1.{ json['table_colseting_tip07']}<i className='icon iconfont icon-ncc-sq' />{json['table_colseting_tip08']}<i className='iconfont icon-shanchu4' />，{json['table_colseting_tip09']}；
                </p>
                <p>2.{json['table_colseting_tip10']}</p>
                <p>3.{json['table_colseting_lock']}：{json['table_colseting_tip06']}<i className='iconfont icon-weisuoding' />{json['table_colseting_tip11']}，{json['table_colseting_tip12']}。</p>
            </div>
        );

        return (
            <div className="setTableColumnDrawer-header">
                <h3 className="title">
                    {json['table_colseting_table']} {/*列表设置*/}
                    <Tooltip
                        placement="right"
                        className='col-setting-tips'
                        overlay={tip}
                    >
                        {/* <i className='iconfont icon-bangzhutishi' /> */}
                        <span className='setting-help-icon'>
                            <i className='iconfont icon-shuoming1' />
                            <i className='iconfont icon-shuoming2' />
                        </span>
                    </Tooltip >
                </h3>
                <div className="headerBtns">
                    <HotKeys
                        keyMap={{
                            sureBtnHandler:
                                HotKeys.USUAL_KEYS.MODAL_CONFIRM,
                            cancelBtnHandler:
                                HotKeys.USUAL_KEYS.MODAL_CANCEL,
                        }}
                        handlers={{
                            sureBtnHandler: () => {
                                const promptBox = document.querySelector('.prompt-box.disabled-bg-btn');
                                if (promptBox) {
                                    return;
                                }
                                // 确定按钮的事件 
                                console.log('sureBtnHandler 事件回调');
                                this.onColsSetting();
                            },
                            cancelBtnHandler: () => {
                                const promptBox = document.querySelector('.prompt-box.disabled-bg-btn');
                                if (promptBox) {
                                    return;
                                }
                                // 重置字段按钮的事件 
                                console.log('cancelBtnHandler 事件回调');
                                toCloseDrawer();
                            },
                        }}
                        className="setting-panel-hotkeys-wrapper"
                        focused={true}
                        attach={document.body}
                        display="inline"
                    />
                    {/* <ButtonGroup list={LIST} />
                    <Button className="cancel-btn" onClick={toCloseDrawer}>
                        {json['table_colseting_cancel'] || '取消'}
                    </Button> */}
                    <ButtonGroup>
                        <Tooltip
                            placement="top"
                            inverse
                            overlay={`${json['table_colseting_ok'] || '保存'} (${HotKeys.USUAL_KEYS.MODAL_CONFIRM})`}
                            trigger={['hover', 'focus']}
                            className="model-helper-overlay"
                        >
                            <Button type="primary" colors="primary" onClick={this.onColsSetting}>
                                {json['table_colseting_ok'] || '保存'}(<span className="text-decoration-underline">Y</span>)
                            </Button>
                        </Tooltip>
                        <Button onClick={this.onColReset}>{json['table_colseting_reset'] || '重置字段'}</Button>
                    </ButtonGroup>
                    <Tooltip
                        placement="top"
                        inverse
                        overlay={`${json['table_colseting_cancel'] || '取消'} (${HotKeys.USUAL_KEYS.MODAL_CANCEL})`}
                        trigger={['focus', 'hover']}
                        className="model-helper-overlay"
                    >
                        <Button onClick={toCloseDrawer}>{json['table_colseting_cancel'] || '取消'}(<span className="text-decoration-underline">N</span>) </Button>
                    </Tooltip>
                </div>
            </div>
        );
        // }
    };

    //拖拽排序列表
    sortColumnList = () => {
        let { tableScope } = this.props;
        let { sortData, rightKeyWord } = this.state;
        let { json = {} } = tableScope.state;

        let alreadShowColumns = sortData.filter(val => val.islock !== true && val.visible === true);
        let lockedData = sortData.filter(val => val.islock === true && val.visible === true);
        let orderIndex = lockedData.length;

        return alreadShowColumns.map((val, index) => {
            return (
                <div key={val.attrcode} className={`${val.visible ? 'show-column' : 'hide-column'} ${rightKeyWord && val.label.includes(rightKeyWord) ? 'selectBykeyword' : ''}`}>
                    <span className="order">{orderIndex + index + 1}</span>
                    <span className="label">{val.label}</span>
                    <Tooltip
                        placement="top"
                        overlay={json['table_colseting_sort']}
                        delayHide={1}
                        delayShow={1000}
                    >
                        <i className={this.iconfontCls('tuozhuai', 'handle')} />
                    </Tooltip>
                    <span onClick={this.ToLockCols.bind(this, val, orderIndex + index + 1)}>
                        <Tooltip
                            placement="top"
                            overlay={json['table_colseting_lock']}
                            delayHide={1}
                            delayShow={1000}
                        >
                            <i
                                className={this.iconfontCls('weisuoding', 'toLock')}
                            />
                        </Tooltip>
                    </span>
                    <span onClick={!(val.noDeletion || val.redstar) && this.ToHideOneCol.bind(this, val)}>
                        <Tooltip
                            placement="top"
                            overlay={json['table_colseting_hide']}
                            delayHide={1}
                            delayShow={1000}
                        >
                            <i
                                className={this.iconfontCls('shanchu4', 'close')}
                                style={(val.noDeletion || val.redstar) ? { color: '#aeaeae', cursor: 'not-allowed' } : {}}
                            />
                        </Tooltip>
                    </span>
                </div>
            );
        });
    };

    render() {
        const { displayData, sortData, leftKeyWord, rightKeyWord } = this.state;
        let lockedData = sortData.filter(val => val.islock === true && val.visible === true);
        let { tableScope, toCloseDrawer } = this.props;
        let { json = {} } = tableScope.state;
        return (
            <Fragment>
                <Sidebox
                    title={this.DrawerHeader()}
                    mask={true}
                    show={true}
                    maskClose={toCloseDrawer}
                    width={1000}
                    onClose={toCloseDrawer}
                    className="setTableColumnDrawer"
                >
                    <div className="TableColumnContent">
                        <div className="TableColumnContent-left-box">
                            <h3 className="TableColumnContent-title">
                                <span>
                                    {json['table_colseting_waitadd']}
                                    {/*待添加*/}
                                </span>
                                <span className="TableColumnContent-title-search">
                                    <Input
                                        value={leftKeyWord}
                                        type="search"
                                        placeholder={json['table_colseting_placeholder']}
                                        onChange={this.handleInputChange.bind(this, 'left')}
                                        onSearch={this.handleInputChange.bind(this, 'left')}
                                        clearSearch={this.handleInputChange.bind(this, 'left', '')}
                                    />
                                </span>
                            </h3>
                            <ul className="TableColumnContent-left">
                                {displayData.filter(e => !!e.showItem).map((val, i) => { //YBP-SCM-BUG-6371 过滤已选字段左侧不显示
                                    let isRowEndItem = false;
                                    if ((i + 1) % 4 === 0) { isRowEndItem = true; }
                                    return (
                                        <li
                                            key={val.attrcode}
                                            className={`per-column ${val.showItem === true ? '' : 'unselectedColumn'} ${isRowEndItem ? 'row-end-item' : ''} ${leftKeyWord && val.label?.includes(leftKeyWord) ? 'selectBykeyword' : ''}`}
                                        >
                                            <div onClick={this.chooseColumn.bind(this, val)}>
                                                <span className="plusBtn">+</span>
                                                {val.required && <span className="unselected-mark">*</span>}
                                                <span className="Column-label">{val.label}</span>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                        <div className="TableColumnContent-right-box">
                            <h3 className="TableColumnContent-title">
                                <span>
                                    {json['table_colseting_readyadd']}
                                    {/*已添加*/}
                                </span>
                                <span className="TableColumnContent-title-search">
                                    <Input
                                        value={rightKeyWord}
                                        placeholder={json['table_colseting_placeholder']}
                                        type="search"
                                        onChange={this.handleInputChange.bind(this, 'right')}
                                        onSearch={this.handleInputChange.bind(this, 'right')}
                                        clearSearch={this.handleInputChange.bind(this, 'right', '')}
                                    />
                                </span>
                            </h3>
                            <div className="TableColumnContent-right">
                                <ul className="lockedCol">
                                    {lockedData.map((val, index) => {
                                        return (
                                            <li key={val.attrcode} className={`${val.visible ? 'show-column' : 'hide-column'} ${rightKeyWord && val.label?.includes(rightKeyWord) ? 'selectBykeyword' : ''}`}>
                                                <span className="order">{index + 1}</span>
                                                <span className="label">{val.label}</span>
                                                {lockedData.length - 1 === index ? (
                                                    <Tooltip
                                                        placement="top"
                                                        overlay={json['table_colseting_lock']}
                                                        delayHide={1}
                                                        delayShow={1000}
                                                    >
                                                        <i
                                                            className={this.iconfontCls('suoding', 'unLock')}
                                                            onClick={this.ToUnLockCols.bind(this, val)}
                                                        />
                                                    </Tooltip>
                                                ) : null}
                                            </li>
                                        );
                                    })}
                                </ul>
                                {this.sortColumnList()?.length ? (
                                    <Dnd
                                        list={this.sortColumnList()}
                                        onStop={this.onDragEnd}
                                        dragClass="alreadyShow-column"
                                        bounds=".TableColumnContent-right"
                                        type="vertical"
                                    />
                                ) : null}
                            </div>
                        </div>
                    </div>
                </Sidebox>
            </Fragment>
        );
    }
}
